module.exports = __webpack_public_path__ + "static/media/60810034-oDTzwSgs.873f89c5.JPG";